import { pathOr, pick } from 'ramda';
import { createSelector } from 'reselect';
import { shallow } from 'zustand/shallow';
import { useSportsbookSelector } from '../../../../store';

const getTopEvent = (eventId, topPreMatchEvents) => {
  for (const { events } of topPreMatchEvents) {
    for (const event of events) {
      if (event.eventId === eventId) {
        return event;
      }
    }
  }

  return null;
};

export const selectTopPreMatchEventFields = (eventId, fields) =>
  createSelector(pathOr([], ['topPreMatchEvents']), (topPreMatchEvents) => {
    const topEvent = getTopEvent(eventId, topPreMatchEvents);

    return pick(fields, topEvent ?? {});
  });

export const useTopPreMatchEventFields = ({ eventId, fields }) =>
  useSportsbookSelector(
    selectTopPreMatchEventFields,
    [eventId, fields],
    shallow
  );

export const selectTopEventFields = (eventId, fields) =>
  createSelector(
    (state) => pathOr([], ['topEvents'], state),
    (topEvents) => {
      const topEventsWithEvents = topEvents.filter(({ events }) => !!events);
      const topEvent = getTopEvent(eventId, topEventsWithEvents);
      return pick(fields, topEvent ? { serviceId: 0, ...topEvent } : {});
    }
  );
// It's need for support old TopEventsMenu
export const useTopEventFields = ({ eventId, fields }) =>
  useSportsbookSelector(selectTopEventFields, [eventId, fields], shallow);
